/**
 * IMPORTS
 */

import { ObservacaoFormModal } from "@components/observacao-form-modal";

import { useStoreZustandSearchShipment } from "@/store-zustand/search-shipment/search-shipment";

type IObservationModalProps = {
  handleToggleCreateActvityModal: () => void;
};

const ObservacaoModal = ({ handleToggleCreateActvityModal }: IObservationModalProps) => {
  const { remessa } = useStoreZustandSearchShipment();

  return (
    <ObservacaoFormModal
      title="Observação da remessa"
      submitLabel="Salvar"
      initialObservacao={String(remessa?.observacao ?? "")}
      isSubmitting={false}
      showSubmit={false}
      textareaDisabled
      onClose={handleToggleCreateActvityModal}
    />
  );
};

export { ObservacaoModal };
